
<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>
        <v-container grid-list-sm>
          <v-layout row wrap justify-space-between>
            <v-flex v-for="(sponsor, i) in standards" :key="i" xs3 md3 sm3 lg3 d-flex ma-2>
              <v-card flat tile class="d-flex">
                <v-img max-height="40" contain :src="sponsor"></v-img>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import logoCimentao from "./img/cimentaologo.jpg";
import logoGerdau from "./img/gerdaulogo.png";
import logoAbc from "./img/abclogo.png";
import logoJoagro from "./img/joagrologo.jpg";

export default {
  data() {
    return {
      standards: [logoCimentao, logoGerdau, logoAbc, logoJoagro]
    };
  },
  methods: {
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  }
};
</script>

<style scoped>
</style>